import React from "react";
import "./NotFound..css";
const NotFound = () => {
  return (
    <div className="mt-5 pt-5 notFound">
      <img
        src="https://cdn.dribbble.com/users/381530/screenshots/3949858/404.gif"
        alt=""
      />
    </div>
  );
};

export default NotFound;
